import { MatchTermsDto } from '@domain/rs/terms/MatchTermsListRs';
import { matchTermsSortMap, MATCH_TERMS_TYPE } from '@domain/constant/v1/termsType';

export default class MatchTermVO {
  contents: string; // 본문
  sn: number;
  title: string; // 제목
  version: number; // 버전
  type: MATCH_TERMS_TYPE; // 타입
  orderIdx: number; // order number
  isRequired: boolean; //필수 여부

  constructor(rs: MatchTermsDto, isRequired: boolean) {
    this.sn = rs.sn;
    this.title = isRequired ? (!rs.title.endsWith('(필수)') ? `${rs.title}(필수)` : rs.title) : `${rs.title}(선택)`;
    this.contents = rs.contents;
    this.version = rs.version;
    this.type = rs.type;
    this.orderIdx = this.getOrderIdx(rs.type);
    this.isRequired = isRequired;
  }

  private getOrderIdx(type: MATCH_TERMS_TYPE) {
    return matchTermsSortMap[type];
  }
}
